import React from 'react';
import {
  Container,
  Card,
  Menu,
  Table,
  Label,
  Message,
  Button,
  Divider,
  Header,
} from 'semantic-ui-react';
import { API } from '../../helpers';

const CodeBlock = ({ code }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{
      background: '#1e1e1e',
      borderRadius: '6px',
      padding: '16px',
      marginTop: '12px',
      position: 'relative',
    }}>
      <pre style={{
        margin: 0,
        color: '#d4d4d4',
        fontFamily: 'Monaco, Consolas, monospace',
        fontSize: '13px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        overflow: 'auto',
        maxHeight: '400px',
      }}>
        <code>{code}</code>
      </pre>
      <Button
        size="small"
        compact
        onClick={handleCopy}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: '#333',
          color: copied ? '#4CAF50' : '#fff',
        }}
      >
        {copied ? '已复制' : '复制'}
      </Button>
    </div>
  );
};

const ModelLabel = ({ children, color = 'blue' }) => (
  <Label size="mini" color={color} style={{ margin: '2px' }}>{children}</Label>
);

class ChannelGuide extends React.Component {
  state = {
    activeTab: 'curl-chat',
    isWhitelist: false,
  };

  handleTabChange = (_e, { name }) => {
    this.setState({ activeTab: name });
  };

  async componentDidMount() {
    // 获取当前用户白名单状态（管理员自动视为白名单）
    let isWhitelist = false;
    try {
      const res = await API.get('/api/user/self');
      if (res.data.success && res.data.data) {
        const user = res.data.data;
        isWhitelist = user.whitelist || user.role >= 10;
        this.setState({ isWhitelist });
      }
    } catch (e) {
      // 忽略错误，默认黑名单
    }

    // 黑名单用户自动切换到可用Tab
    const hiddenTabs = ['curl-chat', 'openclaw-chat'];
    if (!isWhitelist && hiddenTabs.includes(this.state.activeTab)) {
      this.setState({ activeTab: 'curl-aigc' });
    }

    // 处理 URL 锚点跳转
    const hash = window.location.hash.replace('#', '');
    if (hash && ['channel-list', 'curl-chat', 'curl-aigc', 'curl-seedance', 'curl-ali', 'openclaw-chat', 'openclaw-aigc', 'params'].includes(hash)) {
      // 如果是 tab 内容，需要先切换 tab
      if (['curl-chat', 'curl-aigc', 'curl-seedance', 'curl-ali', 'openclaw-chat', 'openclaw-aigc', 'params'].includes(hash)) {
        this.setState({ activeTab: hash });
      }
      // 延迟滚动到目标位置
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }

  handleAnchorClick = (e, tabName) => {
    e.preventDefault();
    this.setState({ activeTab: tabName });
    setTimeout(() => {
      const element = document.getElementById(tabName);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  render() {
    const { isWhitelist } = this.state;
    const baseUrl = window.location.origin;
    const token = 'sk-your-token-here';

    const allChannels = [
      { 
        id: 11, 
        name: 'newapiOpenai', 
        status: '已启用', 
        models: ['gpt-4', 'gpt-4-turbo', 'gpt-4o', 'gpt-4o-mini', 'gpt-image-1', 'gpt-image-1.5', 'gpt-image-2', 'gpt-3.5-turbo', 'gpt-3.5-turbo-16k']
      },
      { 
        id: 10, 
        name: 'newApiGemini', 
        status: '已启用', 
        models: ['gemini-pro', 'gemini-pro-vision', 'gemini-1.5-pro', 'gemini-1.5-pro-latest', 'gemini-1.5-flash', 'gemini-1.5-flash-latest', 'gemini-1.0-pro', 'gemini-exp'] 
      },
      { 
        id: 9, 
        name: 'newApiAwsClaude', 
        status: '已启用', 
        models: ['claude-3-opus-20240229', 'claude-3-sonnet-20240229', 'claude-3-haiku-20240307', 'claude-3.5-sonnet-20240620', 'claude-3.5-haiku-20240724'] 
      },
      { 
        id: 8, 
        name: 'OpenAI (Vt)', 
        status: '已启用', 
        models: ['gpt-4', 'gpt-4-turbo', 'gpt-4o', 'gpt-4o-mini', 'gpt-3.5-turbo'] 
      },
      { 
        id: 7, 
        name: 'Gemini (Vt)', 
        status: '已启用', 
        models: ['gemini-pro', 'gemini-1.5-pro', 'gemini-1.5-flash', 'gemini-pro-vision'] 
      },
      { 
        id: 6, 
        name: 'Claude (Vt)', 
        status: '已启用', 
        models: ['claude-3-opus-20240229', 'claude-3-sonnet-20240229', 'claude-3-haiku-20240307', 'claude-3.5-sonnet-20240620'] 
      },
      {
        id: 4,
        name: '君云aigc',
        status: '已启用',
        models: [
          'junyun-image 图片生成',
          'junyun-image-gg25 图片生成',
          'junyun-video 视频生成',
          'junyun-video-kling30 可灵视频',
          'junyun-video-kling25 可灵视频',
          'junyun-video-klingo1 可灵视频',
          'junyun-video-hailuo23 海螺视频',
          'junyun-video-hailuo23fast 海螺视频',
          'junyun-video-viduq2pro 迹兔视频',
          'junyun-video-viduq3pro 迹兔视频',
          'junyun-video-jimeng 即梦视频',
          'junyun-video-mingmou 明眸视频',
          'junyun-video-gv 视频',
          'junyun-video-os 视频'
        ]
      },
      {
        id: 5,
        name: '阿里百炼',
        status: '已启用',
        models: [
          'qwen-turbo 通义千问',
          'qwen-plus 通义千问',
          'qwen-max 通义千问',
          'qwen-vl-max 视觉理解',
          'qwen-vl-plus 视觉理解',
          'qwen-vl-ocr 文字识别',
          'qwq-32b-preview 深度思考',
          'qvq-72b-preview 视觉推理',
          'wanx-v1 图片生成',
          'deepseek-r1 DeepSeek推理'
        ]
      },
      {
        id: 12,
        name: '腾讯混元3D',
        status: '已启用',
        models: [
          'hy-3d-3.0 文生3D/图生3D',
          'hy-3d-3.1 文生3D/图生3D(八视图)',
          'hy-3d-express 极速版3D生成',
          'hy3-preview 混元3D预览版'
        ]
      },
    ];

    // 黑名单用户过滤国外渠道
    const foreignChannelNames = ['newapiOpenai', 'newApiGemini', 'newApiAwsClaude', 'OpenAI (Vt)', 'Gemini (Vt)', 'Claude (Vt)'];
    const channels = isWhitelist
      ? allChannels
      : allChannels.filter(ch => !foreignChannelNames.includes(ch.name));

    const channelColumns = [
      { key: 'id', title: 'ID', dataIndex: 'id', width: 60 },
      { key: 'name', title: '渠道名称', dataIndex: 'name', width: 140 },
      {
        key: 'status',
        title: '状态',
        dataIndex: 'status',
        width: 80,
        render: (text) => (
          <Label color={text === '已启用' ? 'green' : 'grey'} size="mini">{text}</Label>
        ),
      },
      {
        key: 'models',
        title: '支持模型',
        dataIndex: 'models',
        render: (models) => (
          <div style={{ maxWidth: '800px' }}>
            {models.map((m, i) => (
              <Label key={i} size="mini" style={{ margin: '2px' }}>{m}</Label>
            ))}
          </div>
        ),
      },
    ];

    // curl 示例
    const curlExamples = {
      openai: `# OpenAI (gpt-4)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gpt-4",
    "messages": [
      {"role": "system", "content": "你是一个有帮助的助手"},
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100,
    "temperature": 0.7
  }'`,
      gemini: `# Gemini (gemini-pro)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gemini-pro",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      claude: `# Claude (claude-3-sonnet)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "claude-3-sonnet-20240229",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      vtOpenAi: `# OpenAI (Vt) (gpt-4)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gpt-4",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      vtGemini: `# Gemini (Vt) (gemini-pro)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gemini-pro",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      vtClaude: `# Claude (Vt) (claude-3-sonnet)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "claude-3-sonnet-20240229",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
    };

    const curlAigcExamples = {
      image: `# 图片生成
curl ${baseUrl}/v1/images/generations \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-image",
    "prompt": "一只可爱的橘猫在阳光下打盹",
    "size": "1024x1024",
    "n": 1
  }'`,
      video_kling: `# 可灵视频 (Kling)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-kling30",
    "messages": [
      {"role": "user", "content": "生成一段海边日落的短视频"}
    ],
    "extra_body": {
      "aspect_ratio": "16:9",
      "duration": "5"
    }
  }'`,
      video_vidu: `# 迹兔视频 (Vidu)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-viduq3pro",
    "messages": [
      {"role": "user", "content": "生成一段宇航员在太空行走的视频"}
    ]
  }'`,
      video_hailuo: `# 海螺视频 (Hailuo)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-hailuo23",
    "messages": [
      {"role": "user", "content": "生成一只小猫玩毛线球的动画"}
    ]
  }'`,
      video_jimeng: `# 即梦视频 (Jimeng)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-jimeng",
    "messages": [
      {"role": "user", "content": "生成一只可爱的卡通猫咪在草地上奔跑的视频"}
    ]
  }'`,
      video_os: `# OS 视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-os",
    "messages": [
      {"role": "user", "content": "生成一段未来科技风格的都市夜景视频"}
    ]
  }'`,
      video_seedance_text: `# Seedance - 文生视频
curl ${baseUrl}/v1/images/generations \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "doubao-seedance-2-0-260128",
    "prompt": "生成一段唯美的樱花飘落动画",
    "size": "1280x720"
  }'`,
      video_seedance_image: `# Seedance - 图生视频（上传图片）
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "doubao-seedance-2-0-260128",
    "messages": [{
      "role": "user",
      "content": [
        {"type": "text", "text": "让场景动起来"},
        {"type": "image_url", "image_url": {"url": "https://api.opsmoneye.com/uploads/2026/04/21/xxx.jpg"}}
      ]
    }]
  }'`,
      upload: `# 图片上传接口
curl ${baseUrl}/api/upload/image \\
  -H "Authorization: Bearer ${token}" \\
  -F "file=@/path/to/image.jpg"`,
      upload_curl: `# 图片上传（通过 curl 上传本地文件）
curl ${baseUrl}/api/upload/image \\
  -H "Authorization: Bearer ${token}" \\
  -F "file=@/path/to/your-image.jpg"`,
      // 阿里百炼示例
      ali_chat: `# 阿里百炼 - 对话
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "qwen-plus",
    "messages": [
      {"role": "user", "content": "你好，请介绍一下你自己"}
    ]
  }'`,
      ali_vl: `# 阿里百炼 - 视觉理解（图生文）
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "qwen-vl-max",
    "messages": [
      {
        "role": "user",
        "content": [
          {"type": "image_url", "image_url": {"url": "https://example.com/image.jpg"}},
          {"type": "text", "text": "描述这张图片的内容"}
        ]
      }
    ]
  }'`,
      ali_image: `# 阿里百炼 - 图片生成
curl ${baseUrl}/v1/images/generations \
  -H "Authorization: Bearer ${token}" \
  -H "Content-Type: application/json" \
  -d '{
    "model": "wanx-v1",
    "prompt": "一只可爱的橘猫在阳光下打盹",
    "n": 1,
    "size": "1024*1024"
  }'`,
      // 混元3D示例
      hunyuan3d_text: `# 混元3D - 文生3D
curl ${baseUrl}/v1/chat/completions \
  -H "Authorization: Bearer ${token}" \
  -H "Content-Type: application/json" \
  -d '{
    "model": "hy-3d-3.1",
    "prompt": "一只可爱的卡通小猫"
  }'`,
      hunyuan3d_image: `# 混元3D - 图生3D
curl ${baseUrl}/v1/chat/completions \
  -H "Authorization: Bearer ${token}" \
  -H "Content-Type: application/json" \
  -d '{
    "model": "hy-3d-3.1",
    "image_url": "https://example.com/input.png"
  }'`,
      hunyuan3d_multi: `# 混元3D - 多图生3D（hy-3d-3.0 / hy-3d-3.1 支持）
curl ${baseUrl}/v1/chat/completions \
  -H "Authorization: Bearer ${token}" \
  -H "Content-Type: application/json" \
  -d '{
    "model": "hy-3d-3.1",
    "image_url": "https://example.com/front.png",
    "multi_view_images": [
      {"view_type": "left", "view_image_url": "https://example.com/left.png"},
      {"view_type": "right", "view_image_url": "https://example.com/right.png"},
      {"view_type": "back", "view_image_url": "https://example.com/back.png"}
    ]
  }'`,
      hunyuan3d_query: `# 混元3D - 任务查询
curl ${baseUrl}/v1/aigc/task/TASK_ID \
  -H "Authorization: Bearer ${token}"`,
    };

    // 龙虾配置示例
    const openclawExamples = {
      openai: {
        name: 'OpenAI (newapiOpenai)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gpt-4",
  
  "usage": {
    "chat_endpoint": "/v1/chat/completions",
    "request_format": {
      "model": "gpt-4",
      "messages": [
        {"role": "user", "content": "你好"}
      ],
      "max_tokens": 1000,
      "temperature": 0.7
    }
  },
  
  "models": {
    "gpt-4": {
      "display_name": "GPT-4",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-4-turbo": {
      "display_name": "GPT-4 Turbo",
      "supports vision": true
    },
    "gpt-4o": {
      "display_name": "GPT-4o",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-4o-mini": {
      "display_name": "GPT-4o Mini",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-image-2": {
      "display_name": "GPT Image 2",
      "type": "image_generation"
    },
    "gpt-3.5-turbo": {
      "display_name": "GPT-3.5 Turbo"
    },
    "gpt-3.5-turbo-16k": {
      "display_name": "GPT-3.5 Turbo 16K"
    }
  }
}`,
        usage: '对话接口: /v1/chat/completions | 模型: gpt-4 / gpt-4-turbo / gpt-4o / gpt-4o-mini / gpt-image-2 / gpt-3.5-turbo',
      },
      gemini: {
        name: 'Gemini (newApiGemini)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gemini-2.5-flash",
  
  "usage": {
    "chat_endpoint": "/v1/chat/completions",
    "request_format": {
      "model": "gemini-2.5-flash",
      "messages": [
        {"role": "user", "content": "你好"}
      ],
      "max_tokens": 8192
    }
  },
  
  "models": {
    "gemini-2.5-flash": { "display_name": "Gemini 2.5 Flash" },
    "gemini-2.5-flash-image": { "display_name": "Gemini 2.5 Flash Image", "supports vision": true },
    "gemini-2.5-flash-image-preview": { "display_name": "Gemini 2.5 Flash Image Preview", "supports vision": true },
    "gemini-2.5-flash-lite": { "display_name": "Gemini 2.5 Flash Lite" },
    "gemini-2.5-flash-lite-preview-09-2025": { "display_name": "Gemini 2.5 Flash Lite Preview" },
    "gemini-2.5-flash-nothinking": { "display_name": "Gemini 2.5 Flash No Thinking" },
    "gemini-2.5-flash-preview-09-2025": { "display_name": "Gemini 2.5 Flash Preview" },
    "gemini-2.5-flash-preview-09-2025-nothinking": { "display_name": "Gemini 2.5 Flash Preview No Thinking" },
    "gemini-2.5-flash-preview-tts": { "display_name": "Gemini 2.5 Flash Preview TTS" },
    "gemini-2.5-flash-thinking": { "display_name": "Gemini 2.5 Flash Thinking" },
    "gemini-2.5-flash-thinking-*": { "display_name": "Gemini 2.5 Flash Thinking *" },
    "gemini-2.5-pro": { "display_name": "Gemini 2.5 Pro" },
    "gemini-2.5-pro-nothinking": { "display_name": "Gemini 2.5 Pro No Thinking" },
    "gemini-2.5-pro-thinking": { "display_name": "Gemini 2.5 Pro Thinking" },
    "gemini-2.5-pro-thinking-128": { "display_name": "Gemini 2.5 Pro Thinking 128K" },
    "gemini-2.5-pro-thinking-512": { "display_name": "Gemini 2.5 Pro Thinking 512K" },
    "gemini-3-flash-preview": { "display_name": "Gemini 3 Flash Preview" },
    "gemini-3-flash-preview-nothinking": { "display_name": "Gemini 3 Flash Preview No Thinking" },
    "gemini-3-flash-preview-thinking": { "display_name": "Gemini 3 Flash Preview Thinking" },
    "gemini-3-pro-image-preview": { "display_name": "Gemini 3 Pro Image Preview", "supports vision": true },
    "gemini-3-pro-preview": { "display_name": "Gemini 3 Pro Preview" },
    "gemini-3-pro-preview-thinking": { "display_name": "Gemini 3 Pro Preview Thinking" },
    "gemini-3.1-flash-image-preview": { "display_name": "Gemini 3.1 Flash Image Preview", "supports vision": true },
    "gemini-3.1-flash-lite-preview": { "display_name": "Gemini 3.1 Flash Lite Preview" },
    "gemini-3.1-pro-preview": { "display_name": "Gemini 3.1 Pro Preview" },
    "gemini-3.1-pro-preview-customtools": { "display_name": "Gemini 3.1 Pro Preview Custom Tools" },
    "gemini-3.1-pro-preview-thinking": { "display_name": "Gemini 3.1 Pro Preview Thinking" },
    "gemini-embedding-001": { "display_name": "Gemini Embedding 001" },
    "gemini-flash-latest": { "display_name": "Gemini Flash Latest" },
    "gemini-flash-latest-nothinking": { "display_name": "Gemini Flash Latest No Thinking" },
    "gemini-flash-latest-thinking": { "display_name": "Gemini Flash Latest Thinking" },
    "gemini-flash-latest-thinking-*": { "display_name": "Gemini Flash Latest Thinking *" },
    "gemini-flash-lite-latest": { "display_name": "Gemini Flash Lite Latest" },
    "gemini-flash-lite-latest-nothinking": { "display_name": "Gemini Flash Lite Latest No Thinking" },
    "gemini-flash-lite-latest-thinking": { "display_name": "Gemini Flash Lite Latest Thinking" },
    "gemini-flash-lite-latest-thinking-*": { "display_name": "Gemini Flash Lite Latest Thinking *" }
  }
}`,
        usage: '对话接口: /v1/chat/completions | 模型: gemini-2.5-flash / gemini-2.5-pro / gemini-3-flash-preview / gemini-3.1-pro-preview 等',
      },
      claude: {
        name: 'Claude (newApiAwsClaude)',
        config: `{
  "api_type": "anthropic",
  "base_url": "${baseUrl}",
  "api_key": "${token}",
  "default_model": "claude-sonnet-4-20250514",
  
  "usage": {
    "chat_endpoint": "/v1/chat/completions",
    "request_format": {
      "model": "claude-sonnet-4-20250514",
      "messages": [
        {"role": "user", "content": "你好"}
      ],
      "max_tokens": 8192
    }
  },
  
  "models": {
    "claude-haiku-4-5-20251001": {
      "display_name": "Claude Haiku 4.5",
      "max_tokens": 8192
    },
    "claude-haiku-4-5-20251001-thinking": {
      "display_name": "Claude Haiku 4.5 Thinking",
      "max_tokens": 8192
    },
    "claude-opus-4-1-20250805": {
      "display_name": "Claude Opus 4.1",
      "max_tokens": 8192
    },
    "claude-opus-4-1-20250805-thinking": {
      "display_name": "Claude Opus 4.1 Thinking",
      "max_tokens": 8192
    },
    "claude-opus-4-5-20251101": {
      "display_name": "Claude Opus 4.5",
      "max_tokens": 8192
    },
    "claude-opus-4-5-20251101-thinking": {
      "display_name": "Claude Opus 4.5 Thinking",
      "max_tokens": 8192
    },
    "claude-opus-4-6": {
      "display_name": "Claude Opus 4.6",
      "max_tokens": 8192
    },
    "claude-opus-4-6-thinking": {
      "display_name": "Claude Opus 4.6 Thinking",
      "max_tokens": 8192
    },
    "claude-sonnet-4-20250514": {
      "display_name": "Claude Sonnet 4",
      "max_tokens": 8192
    },
    "claude-sonnet-4-20250514-thinking": {
      "display_name": "Claude Sonnet 4 Thinking",
      "max_tokens": 8192
    },
    "claude-sonnet-4-5-20250929": {
      "display_name": "Claude Sonnet 4.5",
      "max_tokens": 8192
    },
    "claude-sonnet-4-5-20250929-thinking": {
      "display_name": "Claude Sonnet 4.5 Thinking",
      "max_tokens": 8192
    },
    "claude-sonnet-4-6": {
      "display_name": "Claude Sonnet 4.6",
      "max_tokens": 8192
    },
    "claude-sonnet-4-6-thinking": {
      "display_name": "Claude Sonnet 4.6 Thinking",
      "max_tokens": 8192
    }
  }
}`,
        usage: '对话接口: /v1/chat/completions | 模型: claude-sonnet-4 / claude-opus-4 / claude-haiku-4.5 等',
      },
      vtOpenAi: {
        name: 'OpenAI (Vt) (vtOpenAi)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gpt-4.1",
  
  "usage": {
    "chat_endpoint": "/v1/chat/completions",
    "request_format": {
      "model": "gpt-4.1",
      "messages": [
        {"role": "user", "content": "你好"}
      ],
      "max_tokens": 4096
    }
  },
  
  "models": {
    "gpt-4.1": {
      "display_name": "GPT-4.1",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-5": {
      "display_name": "GPT-5",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-5.2": {
      "display_name": "GPT-5.2",
      "supports vision": true,
      "supports function calling": true
    },
    "o3": {
      "display_name": "o3",
      "supports vision": true
    },
    "gpt-4o-mini": {
      "display_name": "GPT-4o Mini",
      "supports vision": true,
      "supports function calling": true
    }
  }
}`,
        usage: '对话接口: /v1/chat/completions | 模型: gpt-4.1 / gpt-5 / gpt-5.2 / o3 / gpt-4o-mini',
      },
      vtGemini: {
        name: 'Gemini (Vt) (vtGemini)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gemini-2.0-flash",
  
  "usage": {
    "chat_endpoint": "/v1/chat/completions",
    "request_format": {
      "model": "gemini-2.0-flash",
      "messages": [
        {"role": "user", "content": "你好"}
      ],
      "max_tokens": 8192
    }
  },
  
  "models": {
    "gemini-2.0-flash": { "display_name": "Gemini 2.0 Flash" },
    "gemini-2.5-flash": { "display_name": "Gemini 2.5 Flash" },
    "gemini-2.5-pro": { "display_name": "Gemini 2.5 Pro" },
    "gemini-3-flash-preview": { "display_name": "Gemini 3 Flash Preview" },
    "gemini-3.1-flash-lite-preview": { "display_name": "Gemini 3.1 Flash Lite Preview" },
    "gemini-3.1-pro-preview": { "display_name": "Gemini 3.1 Pro Preview" }
  }
}`,
        usage: '对话接口: /v1/chat/completions | 模型: gemini-2.0-flash / gemini-2.5-flash / gemini-2.5-pro / gemini-3-flash-preview',
      },
      vtClaude: {
        name: 'Claude (Vt) (vtClaude)',
        config: `{
  "api_type": "anthropic",
  "base_url": "${baseUrl}",
  "api_key": "${token}",
  "default_model": "claude-sonnet-4-6",
  
  "usage": {
    "chat_endpoint": "/v1/chat/completions",
    "request_format": {
      "model": "claude-sonnet-4-6",
      "messages": [
        {"role": "user", "content": "你好"}
      ],
      "max_tokens": 8192
    }
  },
  
  "models": {
    "claude-haiku-4.5": {
      "display_name": "Claude Haiku 4.5",
      "max_tokens": 8192
    },
    "claude-sonnet-4-6": {
      "display_name": "Claude Sonnet 4.6",
      "max_tokens": 8192
    },
    "claude-sonnet-4": {
      "display_name": "Claude Sonnet 4",
      "max_tokens": 8192
    },
    "claude-opus-4": {
      "display_name": "Claude Opus 4",
      "max_tokens": 8192
    },
    "claude-3-haiku": {
      "display_name": "Claude 3 Haiku",
      "max_tokens": 4096
    },
    "claude-3.5-haiku": {
      "display_name": "Claude 3.5 Haiku",
      "max_tokens": 8192
    },
    "claude-sonnet-4.5": {
      "display_name": "Claude Sonnet 4.5",
      "max_tokens": 8192
    },
    "claude-opus-4.5": {
      "display_name": "Claude Opus 4.5",
      "max_tokens": 8192
    },
    "claude-opus-4-6": {
      "display_name": "Claude Opus 4.6",
      "max_tokens": 8192
    }
  }
}`,
        usage: '对话接口: /v1/chat/completions | 模型: claude-sonnet-4-6 / claude-opus-4 / claude-haiku-4.5 等',
      },
    };

    const openclawAigcExamples = {
      image: {
        name: '图片生成',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "junyun-image",
  
  "usage": {
    "image_generation_endpoint": "/v1/images/generations",
    "request_format": {
      "model": "junyun-image",
      "prompt": "图片描述",
      "size": "1024x1024",
      "n": 1
    }
  },
  
  "models": {
    "junyun-image": {
      "display_name": "默认图像生成",
      "task_type": "image_generation",
      "supports_size": ["1024x1024", "1024x1792", "1792x1024"]
    },
    "junyun-image-gg25": {
      "display_name": "GG 2.5 图像模型",
      "task_type": "image_generation",
      "supports_size": ["1024x1024", "1024x1792", "1792x1024"]
    }
  }
}`,
        usage: '图片模型: junyun-image / junyun-image-gg25 | 接口: /v1/images/generations',
      },
      video: {
        name: '视频生成',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "junyun-video",
  
  "usage": {
    "video_generation_endpoint": "/v1/chat/completions",
    "task_status_endpoint": "/v1/aigc/task/{task_id}",
    "request_format": {
      "model": "junyun-video",
      "messages": [
        {"role": "user", "content": "视频提示词"}
      ],
      "duration": 5,
      "task_type": "video_generation"
    }
  },
  
  "models": {
    "junyun-video": { 
      "display_name": "默认视频 (Kling 3.0)", 
      "task_type": "video_generation" 
    },
    "junyun-video-kling30": { 
      "display_name": "可灵视频 3.0", 
      "task_type": "video_generation" 
    },
    "junyun-video-kling25": { 
      "display_name": "可灵视频 2.5", 
      "task_type": "video_generation" 
    },
    "junyun-video-klingo1": { 
      "display_name": "可灵视频 O1", 
      "task_type": "video_generation" 
    },
    "junyun-video-hailuo23": { 
      "display_name": "海螺视频 2.3", 
      "task_type": "video_generation" 
    },
    "junyun-video-hailuo23fast": { 
      "display_name": "海螺视频 2.3-fast", 
      "task_type": "video_generation" 
    },
    "junyun-video-viduq2pro": { 
      "display_name": "迹兔视频 Q2Pro", 
      "task_type": "video_generation" 
    },
    "junyun-video-viduq3pro": { 
      "display_name": "迹兔视频 Q3Pro", 
      "task_type": "video_generation" 
    },
    "junyun-video-jimeng": { 
      "display_name": "即梦视频", 
      "task_type": "video_generation" 
    },
    "junyun-video-mingmou": { 
      "display_name": "明眸视频", 
      "task_type": "video_generation" 
    },
    "junyun-video-gv": { 
      "display_name": "GV 视频", 
      "task_type": "video_generation" 
    },
    "junyun-video-os": { 
      "display_name": "OS 视频", 
      "task_type": "video_generation" 
    }
  }
}`,
        usage: '视频模型: junyun-video | 接口: /v1/chat/completions | 查询: /v1/aigc/task/{task_id}',
      },
    };

    const { activeTab } = this.state;

    return (
      <Container style={{ padding: '20px', maxWidth: '1400px' }}>
        <Header as='h2'>AI聚合平台 渠道使用指南</Header>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          包含 7 个渠道的 curl 和龙虾 (OpenClaw) 调用方式
        </p>

        <Message info>
          <Message.Header>快速导航</Message.Header>
          <p>
            跳转到：
            <a href="#channel-list" onClick={(e) => { e.preventDefault(); document.getElementById('channel-list').scrollIntoView({ behavior: 'smooth' }); }}>渠道列表</a>
            {' | '}
            <a href="#curl-chat" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'curl-chat' }); setTimeout(() => document.getElementById('curl-chat').scrollIntoView({ behavior: 'smooth' }), 100); }}>curl 对话</a>
            {' | '}
            <a href="#curl-aigc" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'curl-aigc' }); setTimeout(() => document.getElementById('curl-aigc').scrollIntoView({ behavior: 'smooth' }), 100); }}>curl AIGC</a>
            {' | '}
            <a href="#openclaw-chat" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'openclaw-chat' }); setTimeout(() => document.getElementById('openclaw-chat').scrollIntoView({ behavior: 'smooth' }), 100); }}>龙虾配置</a>
            {' | '}
            <a href="#openclaw-aigc" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'openclaw-aigc' }); setTimeout(() => document.getElementById('openclaw-aigc').scrollIntoView({ behavior: 'smooth' }), 100); }}>龙虾 AIGC</a>
          </p>
        </Message>

        {/* 渠道列表 */}
        <Card id="channel-list" fluid style={{ marginBottom: '20px' }}>
          <Card.Content>
            <Card.Header>渠道列表</Card.Header>
            <Card.Description>
              <Table celled compact>
                <Table.Header>
                  <Table.Row>
                    {channelColumns.map(col => (
                      <Table.HeaderCell key={col.key} width={col.width}>{col.title}</Table.HeaderCell>
                    ))}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {channels.map(channel => (
                    <Table.Row key={channel.id}>
                      <Table.Cell>{channel.id}</Table.Cell>
                      <Table.Cell>{channel.name}</Table.Cell>
                      <Table.Cell>
                        <Label color={channel.status === '已启用' ? 'green' : 'grey'} size="mini">
                          {channel.status}
                        </Label>
                      </Table.Cell>
                      <Table.Cell>
                        <div style={{ maxWidth: '800px', display: 'flex', flexWrap: 'wrap' }}>
                          {channel.models.map((m, i) => (
                            <Label key={i} size="mini" style={{ margin: '2px' }}>{m}</Label>
                          ))}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Card.Description>
          </Card.Content>
        </Card>

        {/* 基础配置 */}
        <Card fluid style={{ marginBottom: '20px' }}>
          <Card.Content>
            <Card.Header>基础配置</Card.Header>
            <Card.Description>
              <p><strong>API 地址：</strong></p>
              <CodeBlock code={baseUrl} />
              <Divider />
              <p><strong>Token 获取方式：</strong></p>
              <ol style={{ color: '#666' }}>
                <li>登录 AI聚合平台 管理后台</li>
                <li>点击菜单 <strong>令牌</strong> → 点击任意令牌名称进入详情</li>
                <li>复制 <strong>密钥</strong>（格式：sk-xxxxxxxx）</li>
              </ol>
              <Message warning size="small">
                <Message.Header>提示</Message.Header>
                <p>如果没有令牌，请联系管理员创建</p>
              </Message>
            </Card.Description>
          </Card.Content>
        </Card>

        {/* Tab 菜单 */}
        <Menu tabular attached="top" style={{ marginBottom: '20px' }}>
          {isWhitelist && (
            <Menu.Item
              name="curl-chat"
              active={activeTab === 'curl-chat'}
              onClick={this.handleTabChange}
            >
              curl 对话调用
            </Menu.Item>
          )}
          <Menu.Item
            name="curl-aigc"
            active={activeTab === 'curl-aigc'}
            onClick={this.handleTabChange}
          >
            curl AIGC 调用
          </Menu.Item>
          <Menu.Item
            name="curl-seedance"
            active={activeTab === 'curl-seedance'}
            onClick={this.handleTabChange}
          >
            Seedance 视频
          </Menu.Item>
          <Menu.Item
            name="curl-hunyuan3d"
            active={activeTab === 'curl-hunyuan3d'}
            onClick={this.handleTabChange}
          >
            混元3D
          </Menu.Item>
          <Menu.Item
            name="curl-ali"
            active={activeTab === 'curl-ali'}
            onClick={this.handleTabChange}
          >
            阿里百炼
          </Menu.Item>
          {isWhitelist && (
            <Menu.Item
              name="openclaw-chat"
              active={activeTab === 'openclaw-chat'}
              onClick={this.handleTabChange}
            >
              龙虾对话配置
            </Menu.Item>
          )}
          <Menu.Item
            name="openclaw-aigc"
            active={activeTab === 'openclaw-aigc'}
            onClick={this.handleTabChange}
          >
            龙虾 AIGC 配置
          </Menu.Item>
          <Menu.Item
            name="params"
            active={activeTab === 'params'}
            onClick={this.handleTabChange}
          >
            参数说明
          </Menu.Item>
        </Menu>

        {/* curl 对话调用 */}
        {activeTab === 'curl-chat' && (
          <div id="curl-chat">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. OpenAI (newapiOpenai)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">gpt-4</ModelLabel>
                    <ModelLabel color="blue">gpt-4-turbo</ModelLabel>
                    <ModelLabel color="blue">gpt-3.5-turbo</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.openai} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. Gemini (newApiGemini)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="green">gemini-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-flash</ModelLabel>
                    <ModelLabel color="green">gemini-pro-vision</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.gemini} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. Claude (newApiAwsClaude)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="orange">claude-3-opus</ModelLabel>
                    <ModelLabel color="orange">claude-3-sonnet</ModelLabel>
                    <ModelLabel color="orange">claude-3-haiku</ModelLabel>
                    <ModelLabel color="red">claude-3.5-sonnet</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.claude} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. OpenAI (Vt) (vtOpenAi)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">gpt-4</ModelLabel>
                    <ModelLabel color="blue">gpt-4-turbo</ModelLabel>
                    <ModelLabel color="blue">gpt-4o</ModelLabel>
                    <ModelLabel color="blue">gpt-4o-mini</ModelLabel>
                    <ModelLabel color="blue">gpt-3.5-turbo</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.vtOpenAi} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>5. Gemini (Vt) (vtGemini)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="green">gemini-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-flash</ModelLabel>
                    <ModelLabel color="green">gemini-pro-vision</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.vtGemini} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>6. Claude (Vt) (vtClaude)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="orange">claude-3-opus</ModelLabel>
                    <ModelLabel color="orange">claude-3-sonnet</ModelLabel>
                    <ModelLabel color="orange">claude-3-haiku</ModelLabel>
                    <ModelLabel color="red">claude-3.5-sonnet</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.vtClaude} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* curl AIGC 调用 */}
        {activeTab === 'curl-aigc' && (
          <div id="curl-aigc">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>图片生成</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="purple">junyun-image</ModelLabel>
                    <ModelLabel color="purple">junyun-image-gg25</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.image} />
                  <Message info size="small">
                    <Message.Header>可用尺寸</Message.Header>
                    <p>1024x1024 / 1024x1792 / 1792x1024</p>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>可灵视频 (Kling)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="pink">junyun-video-kling30</ModelLabel>
                    <ModelLabel color="pink">junyun-video-kling25</ModelLabel>
                    <ModelLabel color="pink">junyun-video-klingo1</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_kling} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>迹兔视频 (Vidu)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="violet">junyun-video-viduq2pro</ModelLabel>
                    <ModelLabel color="violet">junyun-video-viduq3pro</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_vidu} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>海螺视频 (Hailuo)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="yellow">junyun-video-hailuo23</ModelLabel>
                    <ModelLabel color="yellow">junyun-video-hailuo23fast</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_hailuo} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>即梦视频 (Jimeng)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="pink">junyun-video-jimeng</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_jimeng} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>OS 视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="brown">junyun-video-os</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_os} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>明眸视频 (Mingmou)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="teal">junyun-video-mingmou</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={`# 明眸视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-mingmou",
    "messages": [
      {"role": "user", "content": "生成一段高清视频"}
    ]
  }'`} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>GV 视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="orange">junyun-video-gv</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={`# GV 视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "junyun-video-gv",
    "messages": [
      {"role": "user", "content": "生成一段短视频"}
    ]
  }'`} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云aigc - Seedance 文生视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="teal">Seedance</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_seedance_text} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>duration</code>: 视频时长，支持 5 或 10 秒</li>
                      <li>文生视频：通过文字描述生成视频</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云aigc - Seedance 图生视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="teal">Seedance</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_seedance_image} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>image_url</code>: 参考图片的 URL（需公网可访问）</li>
                      <li><code>duration</code>: 视频时长，支持 5 或 10 秒</li>
                      <li>图生视频：基于参考图片生成动态视频</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* Seedance 视频 */}
        {activeTab === 'curl-seedance' && (
          <div id="curl-seedance">
            <Message info>
              <Message.Header>Seedance 视频生成</Message.Header>
              <p>Seedance 是字节跳动推出的 AI 视频生成模型，支持文生视频和图生视频两种模式。</p>
            </Message>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>支持的模型</Card.Header>
                <Card.Description>
                  <Table compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>模型名称</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell><code>doubao-seedance-2-0-260128</code></Table.Cell>
                        <Table.Cell>文生视频 / 图生视频</Table.Cell>
                        <Table.Cell>Seedance 2.0 最新版</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>doubao-seedance-2-0-fast-260128</code></Table.Cell>
                        <Table.Cell>文生视频 / 图生视频</Table.Cell>
                        <Table.Cell>Seedance 2.0 快速版</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>doubao-seedance-2-0</code></Table.Cell>
                        <Table.Cell>文生视频 / 图生视频</Table.Cell>
                        <Table.Cell>Seedance 2.0 稳定版</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>doubao-seedance-2-0-fast</code></Table.Cell>
                        <Table.Cell>文生视频 / 图生视频</Table.Cell>
                        <Table.Cell>Seedance 2.0 快速稳定版</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                  <Message info size="small">
                    <Message.Header>时长校准规则</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li>视频时长支持范围：<strong>4-15秒</strong>（任意整数）</li>
                      <li>不传或传入0/负数 → 默认 <strong>5秒</strong></li>
                      <li>传入1-3秒 → 校准为 <strong>4秒</strong>（最小值）</li>
                      <li>传入4-15秒 → 使用<strong>传入值</strong>（不修改）</li>
                      <li>传入16秒以上 → 校准为 <strong>15秒</strong>（最大值）</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. 图片上传接口</Card.Header>
                <Card.Description>
                  <Message warning size="small">
                    <Message.Header>重要</Message.Header>
                    <p>图生视频前需先上传参考图片，获取图片 URL 后再调用 Seedance 生成视频。</p>
                  </Message>
                  <CodeBlock code={curlAigcExamples.upload_curl} />
                  <Message info size="small">
                    <Message.Header>上传参数</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>file</code>: 本地图片文件（支持 jpg、png、gif、webp、bmp）</li>
                      <li>文件大小限制：10MB</li>
                    </ul>
                  </Message>
                  <Message info size="small">
                    <Message.Header>响应示例</Message.Header>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
{`{
  "url": "https://api.opsmoneye.com/uploads/2026/04/21/xxx.jpg"
}`}
                    </pre>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. Seedance 文生视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="teal">doubao-seedance-2-0-260128</ModelLabel>
                  </Label.Group>
                  <Message info size="small">
                    <Message.Header>接口说明</Message.Header>
                    <p>使用 <code>/v1/images/generations</code> 接口，通过文字描述生成视频。</p>
                  </Message>
                  <CodeBlock code={curlAigcExamples.video_seedance_text} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>model</code>: 模型名称（如 <code>doubao-seedance-2-0-260128</code>）</li>
                      <li><code>prompt</code>: 视频描述文本</li>
                      <li><code>size</code>: 视频分辨率（如 <code>1280x720</code>）</li>
                    </ul>
                  </Message>
                  <Message info size="small">
                    <Message.Header>响应示例</Message.Header>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
{`{
  "created": 1713686400,
  "data": [{}],
  "task_id": "cgt-20260421140001-mz4n5",
  "status": "PROCESSING",
  "message": "Task created, use /v1/aigc/task/cgt-20260421140001-mz4n5 to query status"
}`}
                    </pre>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. Seedance 图生视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="teal">doubao-seedance-2-0-260128</ModelLabel>
                  </Label.Group>
                  <Message info size="small">
                    <Message.Header>接口说明</Message.Header>
                    <p>使用 <code>/v1/chat/completions</code> 接口，基于参考图片生成视频（多模态格式）。</p>
                  </Message>
                  <Message info size="small">
                    <Message.Header>使用流程</Message.Header>
                    <ol style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li>上传参考图片，获取图片 URL</li>
                      <li>将图片 URL 填入 <code>image_url.url</code> 字段</li>
                      <li>发送请求生成视频</li>
                    </ol>
                  </Message>
                  <CodeBlock code={curlAigcExamples.video_seedance_image} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>model</code>: 模型名称（如 <code>doubao-seedance-2-0-260128</code>）</li>
                      <li><code>image_url.url</code>: 参考图片的完整 URL（上传后获取）</li>
                      <li><code>text</code>: 视频生成指令，如"让场景动起来"</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. 查询视频生成任务</Card.Header>
                <Card.Description>
                  <CodeBlock code={`# 查询任务状态
curl ${baseUrl}/v1/aigc/task/{task_id} \\
  -H "Authorization: Bearer ${token}"`} />
                  <Message info size="small">
                    <Message.Header>任务状态说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>PROCESSING</code>: 任务处理中</li>
                      <li><code>SUCCESS</code>: 任务完成，可获取视频链接</li>
                      <li><code>FAILED</code>: 任务失败（会自动退款）</li>
                    </ul>
                  </Message>
                  <Message info size="small">
                    <Message.Header>响应参数</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>task_id</code>: 任务 ID，用于查询任务状态</li>
                      <li><code>status</code>: 任务状态（PROCESSING/SUCCESS/FAILED）</li>
                      <li><code>progress</code>: 任务进度百分比</li>
                      <li><code>result_url</code>: 视频 URL（SUCCESS 状态时返回）</li>
                      <li><code>created_at</code>: 任务创建时间戳</li>
                      <li><code>updated_at</code>: 任务更新时间戳</li>
                    </ul>
                  </Message>
                  <Message info size="small">
                    <Message.Header>完整响应示例</Message.Header>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
{`# 处理中
{
  "task_id": "cgt-20260421140001-mz4n5",
  "status": "PROCESSING",
  "progress": 50,
  "result_url": "",
  "created_at": 1713686400,
  "updated_at": 1713686410
}

# 已完成
{
  "task_id": "cgt-20260421140001-mz4n5",
  "status": "SUCCESS",
  "progress": 100,
  "result_url": "https://xxx.volces.com/xxx.mp4",
  "created_at": 1713686400,
  "updated_at": 1713686460,
  "video_params": {
    "resolution": "720p",
    "ratio": "16:9",
    "duration": 5,
    "seed": 12345
  }
}

# 已失败
{
  "task_id": "cgt-20260421140001-mz4n5",
  "status": "FAILED",
  "error": "内容安全审核未通过",
  "created_at": 1713686400,
  "updated_at": 1713686410
}`}
                    </pre>
                  </Message>
                  <Message warning size="small">
                    <Message.Header>轮询建议</Message.Header>
                    <p>建议每 3-5 秒轮询一次任务状态，通常视频生成需要 30-60 秒。</p>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>5. 完整使用流程</Card.Header>
                <Card.Description>
                  <Message info size="small">
                    <Message.Header>推荐的工作流程</Message.Header>
                    <ol style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><strong>上传图片</strong> → 获取图片 URL（如果是图生视频）</li>
                      <li><strong>创建任务</strong> → 获取 task_id</li>
                      <li><strong>轮询任务</strong> → 每 3-5 秒查询状态</li>
                      <li><strong>获取结果</strong> → status=FINISH 时获取视频 URL</li>
                    </ol>
                  </Message>
                  <CodeBlock code={`# Python 示例
import requests
import time

base_url = "https://your-oneapi.com"
token = "sk-xxx"

# 1. 上传图片（如需图生视频）
with open("image.jpg", "rb") as f:
    files = {"file": f}
    headers = {"Authorization": f"Bearer {token}"}
    resp = requests.post(f"{base_url}/v1/aigc/upload", files=files, headers=headers)
    image_url = resp.json()["url"]

# 2. 创建视频生成任务
payload = {
    "model": "Seedance",
    "messages": [
        {
            "role": "user",
            "content": [
                {"type": "image_url", "image_url": {"url": image_url}},
                {"type": "text", "text": "让场景动起来"}
            ]
        }
    ],
    "extra_body": {"duration": 5}
}
resp = requests.post(f"{base_url}/v1/chat/completions", json=payload, headers=headers)
task_id = resp.json()["id"]

# 3. 轮询任务状态
while True:
    resp = requests.get(f"{base_url}/v1/aigc/task/{task_id}", headers=headers)
    result = resp.json()
    
    if result["status"] == "FINISH":
        video_url = result["results"][0]
        print(f"视频生成完成: {video_url}")
        break
    elif result["status"] == "FAIL":
        print(f"生成失败: {result.get('error', '未知错误')}")
        break
    
    print(f"任务进行中 ({result.get('progress', 0)}%)...")
    time.sleep(5)  # 每 5 秒轮询一次`} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 混元3D */}
        {activeTab === 'curl-hunyuan3d' && (
          <div id="curl-hunyuan3d">
            <Message info>
              <Message.Header>腾讯混元3D</Message.Header>
              <p>腾讯混元3D 是腾讯推出的 AI 3D 资产生成模型，支持文生3D、单图生3D 和多图生3D。通过 TokenHub OpenAI 兼容接口调用。</p>
            </Message>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>支持的模型</Card.Header>
                <Card.Description>
                  <Table compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>模型名称</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell><code>hy-3d-3.0</code></Table.Cell>
                        <Table.Cell>文生3D / 图生3D / 多图生3D</Table.Cell>
                        <Table.Cell>混元3D 专业版 3.0</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>hy-3d-3.1</code></Table.Cell>
                        <Table.Cell>文生3D / 图生3D / 多图生3D</Table.Cell>
                        <Table.Cell>混元3D 专业版 3.1（推荐）</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>hy-3d-express</code></Table.Cell>
                        <Table.Cell>文生3D / 图生3D</Table.Cell>
                        <Table.Cell>混元3D 极速版</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. 图片上传（图生3D / 多图生3D 前置步骤）</Card.Header>
                <Card.Description>
                  <Message warning size="small">
                    <Message.Header>重要提示</Message.Header>
                    <p>图生3D 和 多图生3D 需要提供公网可访问的图片 URL。您可以使用 One API 的图片上传接口获取 URL，或直接使用自己的图床。</p>
                  </Message>
                  <CodeBlock code={curlAigcExamples.upload} />
                  <Message info size="small">
                    <Message.Header>响应示例</Message.Header>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
{`{
  "url": "https://your-domain.com/uploads/xxx.jpg"
}`}
                    </pre>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. 文生3D</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">hy-3d-3.0</ModelLabel>
                    <ModelLabel color="blue">hy-3d-3.1</ModelLabel>
                    <ModelLabel color="blue">hy-3d-express</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.hunyuan3d_text} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>model</code>: 3D 模型名称（推荐 hy-3d-3.1）</li>
                      <li><code>prompt</code>: 文本描述，描述要生成的3D模型内容</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. 图生3D（单图）</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">hy-3d-3.0</ModelLabel>
                    <ModelLabel color="blue">hy-3d-3.1</ModelLabel>
                    <ModelLabel color="blue">hy-3d-express</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.hunyuan3d_image} />
                  <Message warning size="small">
                    <Message.Header>重要约束</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li>图生3D <strong>不能同时传 prompt 和 image_url</strong>，只能二选一</li>
                      <li><code>image_url</code> 必须公网可访问</li>
                      <li>支持格式：PNG、JPG、JPEG</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. 多图生3D（仅 hy-3d-3.0 / hy-3d-3.1 支持）</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">hy-3d-3.0</ModelLabel>
                    <ModelLabel color="blue">hy-3d-3.1</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.hunyuan3d_multi} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>image_url</code>: 正面主视图图片 URL</li>
                      <li><code>multi_view_images</code>: 多视角辅助图片数组</li>
                      <li><code>view_type</code>: 视角类型，支持 <code>left</code> / <code>right</code> / <code>back</code></li>
                      <li><code>view_image_url</code>: 对应视角的图片 URL</li>
                    </ul>
                  </Message>
                  <Message warning size="small">
                    <Message.Header>约束</Message.Header>
                    <p>多图生3D <strong>不能传 prompt</strong>，只能传图片参数。</p>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>5. 查询3D生成任务</Card.Header>
                <Card.Description>
                  <CodeBlock code={curlAigcExamples.hunyuan3d_query} />
                  <Message info size="small">
                    <Message.Header>任务状态说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>PROCESSING</code>: 任务处理中</li>
                      <li><code>FINISH</code>: 任务完成，可获取3D模型链接</li>
                      <li><code>FAIL</code>: 任务失败</li>
                    </ul>
                  </Message>
                  <Message info size="small">
                    <Message.Header>响应示例</Message.Header>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
{`{
  "id": "1440967241985769472",
  "status": "FINISH",
  "results": [
    "https://xxx.cos.ap-guangzhou.myqcloud.com/xxx.glb"
  ]
}`}
                    </pre>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>6. Python 完整示例</Card.Header>
                <Card.Description>
                  <CodeBlock code={`# Python 示例 - 混元3D 文生3D
import requests
import time

base_url = "https://your-oneapi.com"
token = "sk-xxx"
headers = {"Authorization": f"Bearer {token}", "Content-Type": "application/json"}

# 1. 创建3D生成任务（文生3D）
payload = {
    "model": "hy-3d-3.1",
    "prompt": "一只可爱的卡通小猫"
}
resp = requests.post(f"{base_url}/v1/chat/completions", json=payload, headers=headers)
task_id = resp.json()["id"]
print(f"任务已创建: {task_id}")

# 2. 轮询任务状态
while True:
    resp = requests.get(f"{base_url}/v1/aigc/task/{task_id}", headers=headers)
    result = resp.json()
    
    if result["status"] == "FINISH":
        model_url = result["results"][0]
        print(f"3D模型生成完成: {model_url}")
        break
    elif result["status"] == "FAIL":
        print(f"生成失败: {result.get('error', '未知错误')}")
        break
    
    print(f"任务处理中...")
    time.sleep(5)`} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>计费说明</Card.Header>
                <Card.Description>
                  <Table compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>生成模式</Table.HeaderCell>
                        <Table.HeaderCell>计费方式</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>文生3D / 单图生3D</Table.Cell>
                        <Table.Cell>按次计费</Table.Cell>
                        <Table.Cell>每次请求价格 = 模型配置的「每次价格」</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>多图生3D</Table.Cell>
                        <Table.Cell>按次计费 × 倍率</Table.Cell>
                        <Table.Cell>每次请求价格 = 每次价格 × 补全倍率</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 阿里百炼 */}
        {activeTab === 'curl-ali' && (
          <div id="curl-ali">
            <Message info>
              <Message.Header>阿里云百炼</Message.Header>
              <p>阿里云百炼是阿里巴巴推出的大模型服务平台，基于通义千问等模型，支持对话、视觉理解、图片生成等功能。</p>
            </Message>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>支持的模型</Card.Header>
                <Card.Description>
                  <Table compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>模型名称</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell><code>qwen-plus</code></Table.Cell>
                        <Table.Cell>对话</Table.Cell>
                        <Table.Cell>通义千问 Plus</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>qwen-turbo</code></Table.Cell>
                        <Table.Cell>对话</Table.Cell>
                        <Table.Cell>通义千问 Turbo</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>qwen-max</code></Table.Cell>
                        <Table.Cell>对话</Table.Cell>
                        <Table.Cell>通义千问 Max</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>qwen-vl-max</code></Table.Cell>
                        <Table.Cell>视觉理解</Table.Cell>
                        <Table.Cell>视觉理解模型</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>qwen-vl-plus</code></Table.Cell>
                        <Table.Cell>视觉理解</Table.Cell>
                        <Table.Cell>视觉理解模型 Plus</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>qwq-32b-preview</code></Table.Cell>
                        <Table.Cell>推理</Table.Cell>
                        <Table.Cell>深度思考模型</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>qvq-72b-preview</code></Table.Cell>
                        <Table.Cell>视觉推理</Table.Cell>
                        <Table.Cell>视觉推理模型</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>wanx-v1</code></Table.Cell>
                        <Table.Cell>图片生成</Table.Cell>
                        <Table.Cell>通义万相图片生成</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell><code>deepseek-r1</code></Table.Cell>
                        <Table.Cell>推理</Table.Cell>
                        <Table.Cell>DeepSeek 深度思考</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. 对话接口</Card.Header>
                <Card.Description>
                  <CodeBlock code={curlAigcExamples.ali_chat} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>model</code>: 模型名称（如 <code>qwen-plus</code>、<code>qwen-turbo</code>）</li>
                      <li><code>messages</code>: 对话消息列表</li>
                      <li><code>stream</code>: 是否开启流式输出（可选，默认 false）</li>
                    </ul>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. 视觉理解（图生文）</Card.Header>
                <Card.Description>
                  <CodeBlock code={curlAigcExamples.ali_vl} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>model</code>: 视觉模型（如 <code>qwen-vl-max</code>、<code>qwen-vl-plus</code>）</li>
                      <li><code>image_url.url</code>: 图片 URL（需公网可访问）</li>
                      <li><code>text</code>: 关于图片的问题或指令</li>
                    </ul>
                  </Message>
                  <Message warning size="small">
                    <Message.Header>提示</Message.Header>
                    <p>图片需要公网可访问的 URL，或者可以上传图片后获取 URL。</p>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. 图片生成</Card.Header>
                <Card.Description>
                  <CodeBlock code={curlAigcExamples.ali_image} />
                  <Message info size="small">
                    <Message.Header>参数说明</Message.Header>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                      <li><code>model</code>: 图片生成模型（如 <code>wanx-v1</code>）</li>
                      <li><code>prompt</code>: 图片描述文本</li>
                      <li><code>n</code>: 生成数量（1-4）</li>
                      <li><code>size</code>: 图片尺寸（如 <code>1024*1024</code>、<code>720*1280</code>）</li>
                    </ul>
                  </Message>
                  <Message info size="small">
                    <Message.Header>响应示例</Message.Header>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
{`{
  "created": 1713686400,
  "data": [
    {
      "url": "https://dashscope-result.xxx.com/xxx.jpg"
    }
  ]
}`}
                    </pre>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. 流式输出</Card.Header>
                <Card.Description>
                  <CodeBlock code={`# 阿里百炼 - 流式对话
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "qwen-plus",
    "messages": [
      {"role": "user", "content": "讲一个笑话"}
    ],
    "stream": true
  }'`} />
                  <Message info size="small">
                    <Message.Header>说明</Message.Header>
                    <p>设置 <code>stream: true</code> 开启流式输出，适合实时展示回复内容。</p>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 龙虾对话配置 */}
        {activeTab === 'openclaw-chat' && (
          <div id="openclaw-chat">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. OpenAI 配置 (newapiOpenai)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.openai.usage}</Message>
                  <CodeBlock code={openclawExamples.openai.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. Gemini 配置 (newApiGemini)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.gemini.usage}</Message>
                  <CodeBlock code={openclawExamples.gemini.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. Claude 配置 (newApiAwsClaude)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.claude.usage}</Message>
                  <CodeBlock code={openclawExamples.claude.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. OpenAI (Vt) 配置 (vtOpenAi)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.vtOpenAi.usage}</Message>
                  <CodeBlock code={openclawExamples.vtOpenAi.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>5. Gemini (Vt) 配置 (vtGemini)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.vtGemini.usage}</Message>
                  <CodeBlock code={openclawExamples.vtGemini.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>6. Claude (Vt) 配置 (vtClaude)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.vtClaude.usage}</Message>
                  <CodeBlock code={openclawExamples.vtClaude.config} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 龙虾 AIGC 配置 */}
        {activeTab === 'openclaw-aigc' && (
          <div id="openclaw-aigc">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云aigc - 图片生成配置</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawAigcExamples.image.usage}</Message>
                  <CodeBlock code={openclawAigcExamples.image.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云aigc - 视频生成配置</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawAigcExamples.video.usage}</Message>
                  <CodeBlock code={openclawAigcExamples.video.config} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 参数说明 */}
        {activeTab === 'params' && (
          <div>
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>图片生成参数</Card.Header>
                <Card.Description>
                  <Table celled compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>参数</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>必填</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>model</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>模型名称：junyun-image / junyun-image-gg25</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>prompt</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>图片描述/提示词</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>size</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>尺寸：1024x1024 / 1024x1792 / 1792x1024</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>n</Table.Cell>
                        <Table.Cell>integer</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>生成数量，默认 1，最大 4</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>视频生成参数</Card.Header>
                <Card.Description>
                  <Table celled compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>参数</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>必填</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>model</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>视频模型：junyun-video / junyun-video-kling30 / junyun-video-viduq3pro 等</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>messages</Table.Cell>
                        <Table.Cell>array</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>消息列表，content 为视频描述</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>aspect_ratio</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>比例：16:9 / 9:16 / 1:1</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>duration</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>时长：5 / 10（秒）</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid>
              <Card.Content>
                <Card.Header>对话模型通用参数</Card.Header>
                <Card.Description>
                  <Table celled compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>参数</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>必填</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>model</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>模型名称</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>messages</Table.Cell>
                        <Table.Cell>array</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>消息列表 {"[{role, content}]"}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>temperature</Table.Cell>
                        <Table.Cell>float</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>随机性：0-2，默认 1</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>max_tokens</Table.Cell>
                        <Table.Cell>integer</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>最大生成 token 数</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>top_p</Table.Cell>
                        <Table.Cell>float</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>核采样：0-1</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 注意事项 */}
        <Card fluid style={{ marginTop: '20px' }}>
          <Card.Content>
            <Card.Header>注意事项</Card.Header>
            <Card.Description>
              <ul style={{ color: '#666' }}>
                <li>君云aigc 渠道需要创建令牌，然后复制令牌Key使用</li>
                <li>视频生成是异步任务，接口会立即返回 <code>task_id</code>，请轮询查询结果</li>
                <li>所有请求都需要携带有效的 <code>Authorization</code> Token</li>
                <li>视频生成可能需要较长时间（1-5分钟），请耐心等待</li>
              </ul>
            </Card.Description>
          </Card.Content>
        </Card>
      </Container>
    );
  }
}

export default ChannelGuide;
